"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../../style/index.scss");
require("./index.scss");
// dependencies
require("../../icon/style");
